// components/LoggedInLayout.js
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setLocation } from '../../redux/actions/locationActions';
import { useSelector } from 'react-redux';
import { logoutUser } from '../../redux/actions/authActions';
import axios from 'axios';

function LoggedInLayout() {
    const location = useSelector((state) => state.location.location);
    const navigate = useNavigate();
    const dispatch = useDispatch();
      const [query, setQuery] = useState('');
      const [debouncedQuery, setDebouncedQuery] = useState('');
      const [results, setResults] = useState([]);

  // 1. Debounce input by 800ms
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // 2. Call API when debouncedQuery changes
  useEffect(() => {
    if (!debouncedQuery) {
      setResults([]);
      return;
    }

    // Example fetch — replace with your actual API call
    const fetchCities = async () => {
        console.log('running fetch city')
        try {
          const res = await axios({
            method:'POST',
            url:'https://api.heytout.com/geo/searchforlocation',
            data: {
                search:debouncedQuery
            }
          })
          const data = res;
          console.log(res.data.features)
          setResults(data.data.features);
        } catch (err) {
          console.error('Error fetching cities:', err);
        }
      };
  
      fetchCities();
    }, [debouncedQuery]);

    return (
    <div>
        <div className="tcontainer borderbottom">
            <div className="trow">
                <div className="menuitem"
                    onClick={()=>{
                        navigate('/')
                    }}
                >home</div>
                <div className="menuitem"
                    onClick={()=>{
                        navigate('/addplace')
                    }}
                >add place</div>

                                <div className="tcol vmiddle">
                                <input
                                    type="text"
                                    placeholder="find a city..."
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    className="tinput"
                                    />
                                </div>
                                <div className="tcol vmiddle hmiddle">
                                    {location ? location.place_name : "no location"}
                                </div>
                                <div className="menuitem"
                                    onClick={()=>{
                                        dispatch(logoutUser())
                                    }}
                                >logout</div>

            </div>
            {results.length > 0 &&
                                <div className="row">
                                    {results.map(r=>{
                                        return (
                                            <div onClick={()=>{
                                                dispatch(setLocation(r))
                                                setResults([])
                                            }} className="placename">{r.place_name}</div>
                                        )
                                    })}
                                </div>
                            }

        </div>
      <main>
        <Outlet />
      </main>
    </div>
  );
}

export default LoggedInLayout;
